import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "logoutFilled"
const LogoutFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.75 2.063C13.682 2.063 14.438 2.818 14.438 3.75V9.75H12.562V3.938H3.188V20.063H12.563V14.25H14.437V20.25C14.438 21.182 13.683 21.938 12.75 21.938H3C2.068 21.938 1.313 21.182 1.313 20.25V3.75C1.313 2.818 2.068 2.063 3 2.063z" />
          <path d="M22.7 12 17.164 17.538 15.837 16.212 19.112 12.938H4.5V11.062H19.112L15.837 7.789 17.163 6.462z" />
        </svg>
      }
    </span>
  )
}
export default LogoutFilledIcon
